import { render, staticRenderFns } from "./ModalPresencaParticipantes.vue?vue&type=template&id=cdb819d4&scoped=true"
import script from "./ModalPresencaParticipantes.vue?vue&type=script&lang=js"
export * from "./ModalPresencaParticipantes.vue?vue&type=script&lang=js"
import style0 from "./ModalPresencaParticipantes.vue?vue&type=style&index=0&id=cdb819d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdb819d4",
  null
  
)

export default component.exports